import { render, staticRenderFns } from "./TransitionFade.vue?vue&type=template&id=2aea6026&"
import script from "./TransitionFade.vue?vue&type=script&lang=js&"
export * from "./TransitionFade.vue?vue&type=script&lang=js&"
import style0 from "./TransitionFade.vue?vue&type=style&index=0&id=2aea6026&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports